import { useMutation } from '@apollo/client';
import mutation from 'client/mutations/login';
import user from 'client/queries/user';

export default function useLogin() {
  const refetchQueries = [
    { query: user }
  ];

  const options = { refetchQueries };

  return useMutation(mutation, options);
}
